import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { corHGlobal } from '../servicio/config/config.module';
import { CatalogoParametro } from '../Models/catalogoparametro-dto';
import { Configuracion } from '../Models/configuracion-dto';
import { Subject, Observable } from 'rxjs';
import { timeout, catchError } from 'rxjs/operators';
import { LOCAL_STORAGE, WebStorageService } from 'angular-webstorage-service';
@Injectable({
  providedIn: 'root'
})
export class ServiceCatalogoParametro {

  private actionUrl: string;
  private corsHeadersLocal: HttpHeaders;

  private userLoggedIn = new Subject<boolean>();

  constructor(private corhglobal: corHGlobal, private http: HttpClient, @Inject(LOCAL_STORAGE) private storage: WebStorageService) {
    this.actionUrl = environment.ROOT_URL + '/';
    this.corhglobal.cambioToken(this.storage.get("TOKEN"));
    this.corsHeadersLocal = corhglobal.CORSHEADERS;
    this.userLoggedIn.next(false);
  }
  public getParametroClave() {
    return this.http.post<CatalogoParametro>(this.actionUrl + 'ParametroClave', { headers: this.corsHeadersLocal });
  }
  public getParametroConfiguracion(conf: Configuracion) {
    return this.http.post<Configuracion>(this.actionUrl + 'ParametroConfiguracion', conf, { headers: this.corsHeadersLocal });
  }


  
  
}
